import { FC } from 'react';
import { Skeleton } from 'newcomponents/UI/Skeleton';
import './index.less';

export const MultipleSelectionsCardHeaderSkeleton: FC<{
  hideExpireDate?: boolean;
}> = ({ hideExpireDate = false }) => {
  return (
    <div className="multipleCard__header__wrapper multipleCard__header__skeleton">
      <div className="multipleCard__header">
        <span className="multipleCard__header__title">
          <Skeleton
            title={{ width: 130, style: { margin: 0, height: 19 } }}
            paragraph={false}
            active
          />
        </span>
        {!hideExpireDate ? (
          <Skeleton
            title={{ width: 80, style: { margin: 0, height: 16 } }}
            paragraph={false}
            active
          />
        ) : null}
      </div>
      <div className="multipleCard__header__expireInfo">
        <Skeleton
          title={{ width: 80, style: { margin: 0, height: 24 } }}
          paragraph={false}
          active
        />
      </div>
    </div>
  );
};
